// extracted by mini-css-extract-plugin
export default {"title":"ApplicationTitle_title__qcaKF","version":"ApplicationTitle_version__T-Mcy"};